/* START_MODULE_CONTRACT
 * PURPOSE: Frontend model: FeatureEstimate.
 * SCOPE: DTO mapping / constants.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API
 * ROLE: TYPES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * FeatureEstimate - Frontend model: FeatureEstimate.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: реальный class-контракт и парный END_CLASS.
 * END_CHANGE_SUMMARY
 */

/* START_CLASS_FeatureEstimate */
/* START_CONTRACT: FeatureEstimate
 * PURPOSE: Клиентская модель оценки фичи по роли проекта.
 * INPUTS: { id, projectRoleId, projectRoleName, projectRoleShortName, estimate }.
 * OUTPUTS: экземпляр FeatureEstimate.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-API, M-FEATURE
 * END_CONTRACT: FeatureEstimate
 */
export default class FeatureEstimate {
  constructor({
    id,
    projectRoleId,
    projectRoleName,
    projectRoleShortName,
    estimate,
  }) {
    this.id = id;
    this.projectRoleId = projectRoleId;
    this.projectRoleName = projectRoleName ?? '';
    this.projectRoleShortName = projectRoleShortName ?? '';
    this.estimate = estimate;
  }

  static fromResponse(data) {
    return new FeatureEstimate(data);
  }
}
/* END_CLASS_FeatureEstimate */
